import {
  listBlockedPeriods as publicListBlockedPeriods,
  getOperation as publicGetOperation,
  updateOperation as publicUpdateOperation,
  deleteOperation as publicDeleteOperation,
  queryOperation as publicQueryOperation,
  typedQueryOperation as publicTypedQueryOperation,
  listOperations as publicListOperations,
  listAvailableFulfillmentOptions as publicListAvailableFulfillmentOptions,
  listFirstAvailableTimeSlotForFulfillmentTypes as publicListFirstAvailableTimeSlotForFulfillmentTypes,
  calculateFirstAvailableTimeSlotPerFulfillmentType as publicCalculateFirstAvailableTimeSlotPerFulfillmentType,
  listFirstAvailableTimeSlotsForOperations as publicListFirstAvailableTimeSlotsForOperations,
  calculateFirstAvailableTimeSlotsPerOperation as publicCalculateFirstAvailableTimeSlotsPerOperation,
  listFirstAvailableTimeSlotsForMenus as publicListFirstAvailableTimeSlotsForMenus,
  calculateFirstAvailableTimeSlotsPerMenu as publicCalculateFirstAvailableTimeSlotsPerMenu,
  calculateFirstAvailableTimeSlotsForItem as publicCalculateFirstAvailableTimeSlotsForItem,
  listAvailableTimeSlotsForDate as publicListAvailableTimeSlotsForDate,
  calculateAvailableTimeSlotsForDate as publicCalculateAvailableTimeSlotsForDate,
  listAvailableDatesInRange as publicListAvailableDatesInRange,
  calculateAvailableDatesInRange as publicCalculateAvailableDatesInRange,
  validateOperationAddress as publicValidateOperationAddress,
  bulkUpdateOperationTags as publicBulkUpdateOperationTags,
  bulkUpdateOperationTagsByFilter as publicBulkUpdateOperationTagsByFilter,
} from './restaurants-operations-v1-operation-operations.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  OperationQuery,
  OperationsQueryBuilder,
  typedQueryOperation as universalTypedQueryOperation,
} from './restaurants-operations-v1-operation-operations.universal.js';
import { onOperationDeleted as publicOnOperationDeleted } from './restaurants-operations-v1-operation-operations.public.js';
import { onOperationUpdated as publicOnOperationUpdated } from './restaurants-operations-v1-operation-operations.public.js';

function customQueryOperation(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryOperation(httpClient)(),
    typedQueryFunction: (query: OperationQuery) =>
      publicTypedQueryOperation(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): OperationsQueryBuilder;
  function overloadedQuery(
    query: OperationQuery
  ): ReturnType<typeof universalTypedQueryOperation>;
  function overloadedQuery(query?: OperationQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const listBlockedPeriods: MaybeContext<
  BuildRESTFunction<typeof publicListBlockedPeriods> &
    typeof publicListBlockedPeriods
> = /*#__PURE__*/ createRESTModule(publicListBlockedPeriods);
export const getOperation: MaybeContext<
  BuildRESTFunction<typeof publicGetOperation> & typeof publicGetOperation
> = /*#__PURE__*/ createRESTModule(publicGetOperation);
export const updateOperation: MaybeContext<
  BuildRESTFunction<typeof publicUpdateOperation> & typeof publicUpdateOperation
> = /*#__PURE__*/ createRESTModule(publicUpdateOperation);
export const deleteOperation: MaybeContext<
  BuildRESTFunction<typeof publicDeleteOperation> & typeof publicDeleteOperation
> = /*#__PURE__*/ createRESTModule(publicDeleteOperation);
export const listOperations: MaybeContext<
  BuildRESTFunction<typeof publicListOperations> & typeof publicListOperations
> = /*#__PURE__*/ createRESTModule(publicListOperations);
export const listAvailableFulfillmentOptions: MaybeContext<
  BuildRESTFunction<typeof publicListAvailableFulfillmentOptions> &
    typeof publicListAvailableFulfillmentOptions
> = /*#__PURE__*/ createRESTModule(publicListAvailableFulfillmentOptions);
export const listFirstAvailableTimeSlotForFulfillmentTypes: MaybeContext<
  BuildRESTFunction<
    typeof publicListFirstAvailableTimeSlotForFulfillmentTypes
  > &
    typeof publicListFirstAvailableTimeSlotForFulfillmentTypes
> = /*#__PURE__*/ createRESTModule(
  publicListFirstAvailableTimeSlotForFulfillmentTypes
);
export const calculateFirstAvailableTimeSlotPerFulfillmentType: MaybeContext<
  BuildRESTFunction<
    typeof publicCalculateFirstAvailableTimeSlotPerFulfillmentType
  > &
    typeof publicCalculateFirstAvailableTimeSlotPerFulfillmentType
> = /*#__PURE__*/ createRESTModule(
  publicCalculateFirstAvailableTimeSlotPerFulfillmentType
);
export const listFirstAvailableTimeSlotsForOperations: MaybeContext<
  BuildRESTFunction<typeof publicListFirstAvailableTimeSlotsForOperations> &
    typeof publicListFirstAvailableTimeSlotsForOperations
> = /*#__PURE__*/ createRESTModule(
  publicListFirstAvailableTimeSlotsForOperations
);
export const calculateFirstAvailableTimeSlotsPerOperation: MaybeContext<
  BuildRESTFunction<typeof publicCalculateFirstAvailableTimeSlotsPerOperation> &
    typeof publicCalculateFirstAvailableTimeSlotsPerOperation
> = /*#__PURE__*/ createRESTModule(
  publicCalculateFirstAvailableTimeSlotsPerOperation
);
export const listFirstAvailableTimeSlotsForMenus: MaybeContext<
  BuildRESTFunction<typeof publicListFirstAvailableTimeSlotsForMenus> &
    typeof publicListFirstAvailableTimeSlotsForMenus
> = /*#__PURE__*/ createRESTModule(publicListFirstAvailableTimeSlotsForMenus);
export const calculateFirstAvailableTimeSlotsPerMenu: MaybeContext<
  BuildRESTFunction<typeof publicCalculateFirstAvailableTimeSlotsPerMenu> &
    typeof publicCalculateFirstAvailableTimeSlotsPerMenu
> = /*#__PURE__*/ createRESTModule(
  publicCalculateFirstAvailableTimeSlotsPerMenu
);
export const calculateFirstAvailableTimeSlotsForItem: MaybeContext<
  BuildRESTFunction<typeof publicCalculateFirstAvailableTimeSlotsForItem> &
    typeof publicCalculateFirstAvailableTimeSlotsForItem
> = /*#__PURE__*/ createRESTModule(
  publicCalculateFirstAvailableTimeSlotsForItem
);
export const listAvailableTimeSlotsForDate: MaybeContext<
  BuildRESTFunction<typeof publicListAvailableTimeSlotsForDate> &
    typeof publicListAvailableTimeSlotsForDate
> = /*#__PURE__*/ createRESTModule(publicListAvailableTimeSlotsForDate);
export const calculateAvailableTimeSlotsForDate: MaybeContext<
  BuildRESTFunction<typeof publicCalculateAvailableTimeSlotsForDate> &
    typeof publicCalculateAvailableTimeSlotsForDate
> = /*#__PURE__*/ createRESTModule(publicCalculateAvailableTimeSlotsForDate);
export const listAvailableDatesInRange: MaybeContext<
  BuildRESTFunction<typeof publicListAvailableDatesInRange> &
    typeof publicListAvailableDatesInRange
> = /*#__PURE__*/ createRESTModule(publicListAvailableDatesInRange);
export const calculateAvailableDatesInRange: MaybeContext<
  BuildRESTFunction<typeof publicCalculateAvailableDatesInRange> &
    typeof publicCalculateAvailableDatesInRange
> = /*#__PURE__*/ createRESTModule(publicCalculateAvailableDatesInRange);
export const validateOperationAddress: MaybeContext<
  BuildRESTFunction<typeof publicValidateOperationAddress> &
    typeof publicValidateOperationAddress
> = /*#__PURE__*/ createRESTModule(publicValidateOperationAddress);
export const bulkUpdateOperationTags: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateOperationTags> &
    typeof publicBulkUpdateOperationTags
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateOperationTags);
export const bulkUpdateOperationTagsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateOperationTagsByFilter> &
    typeof publicBulkUpdateOperationTagsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateOperationTagsByFilter);
export const queryOperation: MaybeContext<
  BuildRESTFunction<typeof customQueryOperation> & typeof customQueryOperation
> = /*#__PURE__*/ createRESTModule(customQueryOperation);
/**
 * Triggered when an operation is deleted.
 */
export const onOperationDeleted: BuildEventDefinition<
  typeof publicOnOperationDeleted
> &
  typeof publicOnOperationDeleted = createEventModule(publicOnOperationDeleted);
/**
 * Triggered when an operation is updated.
 */
export const onOperationUpdated: BuildEventDefinition<
  typeof publicOnOperationUpdated
> &
  typeof publicOnOperationUpdated = createEventModule(publicOnOperationUpdated);

export {
  SchedulingType,
  PreparationTimeType,
  TimeUnit,
  AsapPreorderType,
  AsapPacingWindowType,
  ActivationType,
  EntitiesDayOfWeek,
  MethodType,
  FulfillmentTimesType,
  PreorderPacingWindowType,
  OnlineOrderingStatusType,
  FulfillmentType,
  PreparationTimePreparationTimeType,
  AsapFutureHandlingType,
  SortOrder,
  SubdivisionType,
  FulfillmentTimeType,
  FulfillmentTimesDisplayType,
  TimeSlotStatus,
  OrderSchedulingType,
  TimeSlotForFulfillmentTimeSlotStatus,
  ViolationType,
  PlacementType,
  DayOfWeek,
  ResolutionMethod,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './restaurants-operations-v1-operation-operations.universal.js';
export {
  Operation,
  OperationOnlineOrderingStatusOptionsOneOf,
  Scheduling,
  SchedulingSchedulingOptionsOneOf,
  AsapScheduling,
  AsapSchedulingPreparationTimeOneOf,
  AsapSchedulingAsapPreorderOneOf,
  TimeDuration,
  TimeDurationRange,
  BusinessDaysPreorder,
  AsapOrderPacing,
  AsapOrderPacingPacingAvailabilityOneOf,
  WeeklyActivePeriods,
  ActivePeriod,
  TimeOfDayRange,
  TimeOfDay,
  PreorderScheduling,
  PreorderMethod,
  PreorderMethodMethodOptionsOneOf,
  DayAndTime,
  TimeBounded,
  WeeklySchedule,
  FulfillmentTimesDisplayConfig,
  FulfillmentTimesDisplayConfigFulfillmentTimesDisplayOptionsOneOf,
  PreOrderPacing,
  PreOrderPacingPacingAvailabilityOneOf,
  WeeklyActiveDays,
  OnlineOrderingPausedUntilOptions,
  OrderScheduling,
  OrderSchedulingOrderSchedulingOptionsOneOf,
  AsapOrderScheduling,
  AsapOrderSchedulingAsapFutureHandlingOptionsOneOf,
  PreparationTime,
  PreparationTimeTimeSpecificationOneOf,
  BusinessDaysAheadHandling,
  BusinessLocationDetails,
  V1Address,
  V1StreetAddress,
  V1AddressLocation,
  ExtendedFields,
  Tags,
  TagList,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  ListBlockedPeriodsRequest,
  ListBlockedPeriodsResponse,
  BlockedPeriod,
  ListOrdersForOperationRequest,
  CursorPaging,
  ListOrdersForOperationResponse,
  PacingOrder,
  CursorPagingMetadata,
  Cursors,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  DeliveryProfileConfiguredForOperation,
  OperationsDataCloningCompleted,
  GetOperationRequest,
  GetOperationResponse,
  UpdateOperationRequest,
  UpdateOperationResponse,
  DeleteOperationRequest,
  DeleteOperationResponse,
  QueryOperationRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CommonCursorPaging,
  QueryOperationResponse,
  CommonCursorPagingMetadata,
  CommonCursors,
  ListOperationsRequest,
  ListOperationsResponse,
  ListOperationIdsRequest,
  ListOperationIdsResponse,
  ListOperationsInternalRequest,
  ListOperationsInternalResponse,
  ListAvailableFulfillmentOptionsRequest,
  CommonAddress,
  CommonAddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  ListAvailableFulfillmentOptionsResponse,
  FulfillmentOption,
  FulfillmentOptionFulfillmentTimeOptionsOneOf,
  FulfillmentOptionFulfillmentTimesDisplayOptionsOneOf,
  FulfillmentOptionFulfillmentTypeOptionsOneOf,
  FulfillmentOptionAvailability,
  DayOfWeekAvailability,
  AvailabilityException,
  DurationRange,
  TimeWindowDisplayConfig,
  PickupDetails,
  DeliveryDetails,
  DineInDetails,
  ListFirstAvailableTimeSlotForFulfillmentTypesRequest,
  ListFirstAvailableTimeSlotForFulfillmentTypesResponse,
  FulfillmentTimeSlot,
  FulfillmentDetails,
  FulfillmentDetailsFulfillmentTimeOptionsOneOf,
  FulfillmentAddress,
  CalculateFirstAvailableTimeSlotPerFulfillmentTypeRequest,
  CalculateFirstAvailableTimeSlotPerFulfillmentTypeResponse,
  TimeSlotForFulfillment,
  TimeSlot,
  FulfillmentInfo,
  FulfillmentInfoFulfillmentTimeOneOf,
  ListFirstAvailableTimeSlotsForOperationsRequest,
  ListFirstAvailableTimeSlotsForOperationsResponse,
  OperationTimeSlot,
  CalculateFirstAvailableTimeSlotsPerOperationRequest,
  CalculateFirstAvailableTimeSlotsPerOperationResponse,
  TimeSlotForOperation,
  ListFirstAvailableTimeSlotsForMenusRequest,
  ListFirstAvailableTimeSlotsForMenusResponse,
  FirstFulfillmentTimeSlotsPerMenu,
  CalculateFirstAvailableTimeSlotsPerMenuRequest,
  CalculateFirstAvailableTimeSlotsPerMenuResponse,
  FulfillmentTimeSlotsPerMenu,
  PagingMetadata,
  CalculateFirstAvailableTimeSlotsForItemRequest,
  CalculateFirstAvailableTimeSlotsForItemResponse,
  ListAvailableTimeSlotsForDateRequest,
  _Date,
  ListAvailableTimeSlotsForDateResponse,
  CalculateAvailableTimeSlotsForDateRequest,
  CalculateAvailableTimeSlotsForDateResponse,
  ListAvailableDatesInRangeRequest,
  ListAvailableDatesInRangeResponse,
  FulfillmentTypeAvailableDates,
  CalculateAvailableDatesInRangeRequest,
  CalculateAvailableDatesInRangeResponse,
  GetExpectedFulfillmentSelectionRequest,
  GetExpectedFulfillmentSelectionResponse,
  UpdateImmutableFieldsRequest,
  ImmutableFields,
  UpdateImmutableFieldsResponse,
  ValidateOperationAddressRequest,
  ValidateOperationAddressResponse,
  AddressViolation,
  UpdateDeliveryRegionsRequest,
  UpdateDeliveryRegionsResponse,
  BulkUpdateOperationTagsRequest,
  BulkUpdateOperationTagsResponse,
  ItemMetadata,
  ApplicationError,
  BulkUpdateOperationTagsResult,
  BulkActionMetadata,
  BulkUpdateOperationTagsByFilterRequest,
  BulkUpdateOperationTagsByFilterResponse,
  SitePropertiesNotification,
  SitePropertiesEvent,
  Properties,
  Categories,
  Locale,
  Address,
  AddressHint,
  GeoCoordinates,
  BusinessSchedule,
  TimePeriod,
  SpecialHourPeriod,
  Multilingual,
  SupportedLanguage,
  ConsentPolicy,
  Translation,
  ChangeContext,
  ChangeContextPayloadOneOf,
  PropertiesChange,
  V4SiteCreated,
  SiteCloned,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  OperationDeletedEnvelope,
  OperationUpdatedEnvelope,
  ListBlockedPeriodsOptions,
  UpdateOperation,
  OperationsQueryResult,
  OperationsQueryBuilder,
  OperationQuerySpec,
  ListAvailableFulfillmentOptions,
  ListFirstAvailableTimeSlotForFulfillmentTypesOptions,
  CalculateFirstAvailableTimeSlotPerFulfillmentTypeOptions,
  ListFirstAvailableTimeSlotsForOperationsOptions,
  CalculateFirstAvailableTimeSlotsPerOperationOptions,
  ListFirstAvailableTimeSlotsForMenusOptions,
  CalculateFirstAvailableTimeSlotsPerMenuOptions,
  CalculateFirstAvailableTimeSlotsForItemOptions,
  ListAvailableTimeSlotsForDateOptions,
  CalculateAvailableTimeSlotsForDateOptions,
  ListAvailableDatesInRangeOptions,
  CalculateAvailableDatesInRangeOptions,
  BulkUpdateOperationTagsOptions,
  BulkUpdateOperationTagsByFilterOptions,
} from './restaurants-operations-v1-operation-operations.universal.js';
export { utils } from './restaurants-operations-v1-operation-operations.universal.js';
export {
  SchedulingTypeWithLiterals,
  PreparationTimeTypeWithLiterals,
  TimeUnitWithLiterals,
  AsapPreorderTypeWithLiterals,
  AsapPacingWindowTypeWithLiterals,
  ActivationTypeWithLiterals,
  EntitiesDayOfWeekWithLiterals,
  MethodTypeWithLiterals,
  FulfillmentTimesTypeWithLiterals,
  PreorderPacingWindowTypeWithLiterals,
  OnlineOrderingStatusTypeWithLiterals,
  FulfillmentTypeWithLiterals,
  PreparationTimePreparationTimeTypeWithLiterals,
  AsapFutureHandlingTypeWithLiterals,
  SortOrderWithLiterals,
  SubdivisionTypeWithLiterals,
  FulfillmentTimeTypeWithLiterals,
  FulfillmentTimesDisplayTypeWithLiterals,
  TimeSlotStatusWithLiterals,
  OrderSchedulingTypeWithLiterals,
  TimeSlotForFulfillmentTimeSlotStatusWithLiterals,
  ViolationTypeWithLiterals,
  PlacementTypeWithLiterals,
  DayOfWeekWithLiterals,
  ResolutionMethodWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  BulkUpdateOperationTagsApplicationErrors,
  BulkUpdateOperationTagsByFilterApplicationErrors,
  CommonQueryWithEntityContext,
  OperationQuery,
} from './restaurants-operations-v1-operation-operations.universal.js';
